import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { ReportKindInfo } from "projects/sepidz-web-framework-data-grid/src/lib/report-kind";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { SubLedger } from "../../models/subledger.model";
import { VoucherInfo } from "../../models/voucherInfo.model";
import { GeneralLedgerVoucher } from "../general-ledger-voucher.model";

@Component({
  selector: "ngx-general-ledger-voucher-form",
  templateUrl: "./general-ledger-voucher-form.component.html",
  styleUrls: ["./general-ledger-voucher-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralLedgerVoucherFormComponent extends BaseFormComponent<GeneralLedgerVoucher> {
  DefaultValues: Dictionary = [];
  isLoadingMaxNUmber: boolean;
  erroremessage: string;
  currentSubLedger: SubLedger;
  reportKinds = ReportKindInfo.reportKinds;
  GeneralLedgerVoucherDetails: form_control[];
  constructor(
    __id: FormContainerModel,
    _tabsservice: TabularService,
    protected cd: ChangeDetectorRef,
    public selectorService: SelectorService,
    private datatransfer: Datatransfer
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.currentrow = this.datatransfer?.currentrow;
    if (this.datatransfer?.apiName) this.apiName = this.datatransfer?.apiName;
    if (this.datatransfer?.label) this.label = this.datatransfer?.label;
    if (this.datatransfer?.areaName) this.areaName = this.datatransfer?.areaName;
    this.tabsservice = _tabsservice;
  }
  async ngOnInit() {
    this.DefaultValues["GeneralLedgerVoucherHeaderId"] = 0;
    this.apiName = "GeneralLedgerVoucherHeader";
    this.label = "سند کل";
    this.reportName = "GeneralLedgerVoucherDocument";
    this.pathPreFix = "ACC";
    super.ngOnInit();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.DefaultValues = undefined;
    this.GeneralLedgerVoucherDetails = undefined;
  }
  setdefault() {
    if (!this.model.GeneralLedgerVoucherDetails) this.model.GeneralLedgerVoucherDetails = [];
  }
  setMaxCode() {
    if (!this.isNewRow && this.model.Id > 0) return;
    if (!this.accountService.authService.currentFiscalYear) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.isLoadingMaxNUmber = true;
          const voucherInfo = new VoucherInfo();
          voucherInfo.VoucherDate = new Date();
          voucherInfo.FiscalYearId = x.Id;
          voucherInfo.BranchId = this.accountService.authService.currentBranchId;
          this.httpCommonService
            .create(`${this.apiName}/GetMaxNumber`, voucherInfo)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.isLoadingMaxNUmber = false;
                  this.model["EndVchDate"] = data["EndVchDate"];
                  this.model["EndVchNum"] = data["EndVchNum"];
                  this.model["GeneralLedgerVoucherNo"] = data["GeneralLedgerVoucherNo"];
                  this.model["StartVchDate"] = data["StartVchDate"];
                  this.model["StartVchNum"] = data["StartVchNum"];
                  this.model["DateGenerated"] = data["DateGenerated"];
                  this.model["FiscalYearId"] = data["FiscalYearId"];
                  this.model["BranchId"] = data["BranchId"];
                  this.setdefault();
                  this.setFormGroup(this.model);
                  this.cd.markForCheck();
                }
              },
              (error) => {
                this.getFailedHelper(error);
                this.isLoadingMaxNUmber = false;
              }
            );
        }
      });
    } else if (!this.isLoadingMaxNUmber) {
      this.isLoadingMaxNUmber = true;
      const voucherInfo = new VoucherInfo();
      voucherInfo.VoucherDate = new Date();
      voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      voucherInfo.BranchId = this.accountService.authService.currentBranchId;
      this.httpCommonService
        .create(`${this.apiName}/GetMaxNumber`, voucherInfo)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            if (data) {
              this.isLoadingMaxNUmber = false;
              this.model["EndVchDate"] = data["EndVchDate"];
              this.model["EndVchNum"] = data["EndVchNum"];
              this.model["GeneralLedgerVoucherNo"] = data["GeneralLedgerVoucherNo"];
              this.model["StartVchDate"] = data["StartVchDate"];
              this.model["StartVchNum"] = data["StartVchNum"];
              this.model["DateGenerated"] = data["DateGenerated"];
              this.model["FiscalYearId"] = data["FiscalYearId"];
              this.model["BranchId"] = data["BranchId"];
              this.setdefault();
              this.setFormGroup(this.model);
            }
          },
          (error) => {
            this.getFailedHelper(error);
            this.isLoadingMaxNUmber = false;
          }
        );
    }
  }
  isValid() {
    let flag: boolean = this.isNewRow;
    this.erroremessage = undefined;
    if (flag && !this.formGroup.controls["FiscalYearId"].value) {
      if (!this.formGroup.controls["FiscalYearId"].value && !this.accountService.authService.currentFiscalYear) {
        this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
          if (x) this.setValue("FiscalYearId", x.Id);
        });
        this.erroremessage = `سال مالی انتخاب نشده است.`;
        flag = false;
      } else if (this.accountService.authService.currentFiscalYear)
        this.setValue("FiscalYearId", this.accountService.authService.currentFiscalYear.Id);
      return flag;
    }
    if (flag && (!this.model.GeneralLedgerVoucherDetails || this.model.GeneralLedgerVoucherDetails.length <= 0)) {
      this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
      flag = false;
    }
    return flag;
  }
  createVoucher() {
    this.httpCommonService
      .create(`${this.apiName}/GetGeneralVoucher`, this.getDataFromFormGroup())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.isLoadingMaxNUmber = false;
            this.model.GeneralLedgerVoucherDetails = data as [];
            this.isValid();
            this.cd.markForCheck();
          }
        },
        (error) => {
          this.getFailedHelper(error);
          this.isLoadingMaxNUmber = false;
        }
      );
  }
  deleteVoucher() {
    this.sts.showDialog(`آیا از حذف اطلاعات اطمینان دارید؟`, "حذف اطلاعات", DialogType.confirm, () => this.removeVoucher());
  }
  removeVoucher() {
    this.sts.showToast("primary", "", "در حال حذف...");
    this.httpCommonService
      .delete(this.apiName, this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (results) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
          setTimeout(() => this.close(), 200);
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  getMaxDateNumber() {
    if (!this.isLoadingMaxNUmber) {
      this.isLoadingMaxNUmber = true;
      this.httpCommonService
        .create(`${this.apiName}/GetMaxDateNumber`, this.getDataFromFormGroup())
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            if (data) {
              this.model["EndVchDate"] = data["EndVchDate"];
              this.setValue("EndVchDate", this.model["EndVchDate"]);
              if (this.formGroup.controls["EndVchNum"].value > data["EndVchNum"]) {
                this.model["EndVchNum"] = data["EndVchNum"];
                this.setValue("EndVchNum", this.model["EndVchNum"]);
              }
              this.isLoadingMaxNUmber = false;
            }
          },
          (error) => {
            this.getFailedHelper(error);
            this.isLoadingMaxNUmber = false;
          }
        );
    }
  }
  onChanged($event) {
    if (this.formGroup.invalid) return;
    if ($event.GeneralLedgerId) {
      this.currentSubLedger = $event;
      this.setColumnAttribute();
    }
    if (
      new Date(this.model.EndVchDate).toDateString() !== new Date(this.formGroup.controls["EndVchDate"].value).toDateString() ||
      this.model.EndVchNum !== this.formGroup.controls["EndVchNum"].value
    ) {
      if (!this.isLoadingMaxNUmber) {
        setTimeout(() => {
          this.getMaxDateNumber();
        }, 200);
      }
    }
    this.isValid();
  }
  setColumnAttribute() {
    this.columns.forEach((x) => {
      x.disabled = !this.isNewRow;
    });
    this.columns.forEach((x) => {
      if (x.name === "GeneralLedgerVoucherNo") x.disabled = true;
      if (x.name === "StartVchDate") {
        x.disabled = true;
      }
      if (x.name === "StartVchNum") {
        x.disabled = true;
      }
    });
    this.GeneralLedgerVoucherDetails = this.getDetailControlModels("GeneralLedgerVoucherDetails");

    this.columns.forEach((x) => ((x.isFloat = null), (x.userClass = null)));
    this.cd.markForCheck();
  }
  beforupdate() {
    if (this.model.GeneralLedgerVoucherDetails && this.model.GeneralLedgerVoucherDetails.length > 0) {
      if (!this.formGroup.controls["GeneralLedgerVoucherDetails"])
        this.formGroup.addControl("GeneralLedgerVoucherDetails", new UntypedFormControl(this.model.GeneralLedgerVoucherDetails));
      else this.formGroup.controls["GeneralLedgerVoucherDetails"].setValue(this.model.GeneralLedgerVoucherDetails);
      this.formGroup.updateValueAndValidity();
    } else this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
  }
}
